export class ConfirmationCancelAction {
  public static readonly type =
    '[Project/Storage/List] ConfirmationCancelAction';
}
